import Service from './Service';
// import Server from './server';
import UserAccount from './UserAccount';
// import { XML_ATTR, POST_ATTR } from '../models/nodeattributes';
import TreeCache from './cache/TreeCache';

class CreateProject extends Service {
  initialize() {
    this.mediaUploadTilesQueued = new Set();
    this.isCreatingProject = false;
  }
  queueMediaUploadTile(mediaUploadTile) {
    this.mediaUploadTilesQueued.add(mediaUploadTile);
  }
  unqueueMediaUploadTile(mediaUploadTile) {
    this.mediaUploadTilesQueued.delete(mediaUploadTile);
  }
  get numberOfQueuedUploads() {
    return this.mediaUploadTilesQueued.size;
  }
  tryStartCreate() {
    if (this.isCreatingProject) return false;
    this.isCreatingProject = true;
    this.emitStateUpdate();
    return true;
  }
  finishCreate() {
    this.isCreatingProject = false;
    this.emitStateUpdate();
  }
  /** Release the submit lock when the create settles; hand the result to `cb`. */
  settleCreate(pending, cb) {
    const done = (ok) => {
      this.finishCreate();
      if (cb) cb(ok);
    };
    if (!pending || typeof pending.then !== 'function') return done(false);
    return pending.then((results) => done(!!(results && results._id && !results.error))).catch(() => done(false));
  }
  registerAndCreateProject(tree, email, team, cb) {
    if (!this.tryStartCreate()) return;
    UserAccount.registerAccount({ email }).then((r) => {
      if (!r || !r._id) {
        this.finishCreate();
        return cb && cb(false);
      }
      if (this.mediaUploadTilesQueued.size > 0) {
        this.emitStateUpdate();
        const tiles = [...this.mediaUploadTilesQueued];
        Promise.all(tiles.map(async (mediaUploadTile) => {
          try {
            return await mediaUploadTile.resumeUpload(r._id);
          } catch {
            return false;
          }
        })).then((results) => {
          tiles.forEach((tile) => this.mediaUploadTilesQueued.delete(tile));
          if (results.some((uploaded) => uploaded === false)) {
            this.finishCreate();
            return cb && cb(false);
          }
          this.__createProjectAfterRegister(tree, team, r, cb);
        }).catch(() => {
          tiles.forEach((tile) => this.mediaUploadTilesQueued.delete(tile));
          this.finishCreate();
          return cb && cb(false);
        });
      } else {
        this.__createProjectAfterRegister(tree, team, r, cb);
      }
    }).catch(() => {
      this.finishCreate();
      return cb && cb(false);
    });
  }
  createProject(tree, team, cb) {
    if (!this.tryStartCreate()) return;
    const steps = tree.getFormattedActionSteps();
    this.settleCreate(TreeCache.createTree(tree, null, team, steps), cb);
  }
  __createProjectAfterRegister(tree, team, r, cb) {
    tree.userLoggedIn = r._id;
    const steps = tree.getFormattedActionSteps();
    this.settleCreate(TreeCache.createTree(tree, null, team, steps), cb);
  }
}
// function RunActions(tree) {
//   const steps = tree.getFormattedActionSteps();
//   steps.forEach(RunStep);
// }
// function RunStep(step) {
//   if (step && step.type === POST_ATTR && step.format === XML_ATTR) {
//     const { url, body } = step;
//     Server.__postRequest('/restfulapi', {
//       url,
//       method: 'POST',
//       body,
//       headers: {
//         'Content-Type': 'application/xml'
//       }
//     });
//   }
// }

const singleton = new CreateProject();
singleton.initialize();
export default singleton;

